import { ChangeDetectionStrategy, Component, Inject } from '@angular/core';
import { CommonModule } from '@angular/common';
import { CdkOverlayOrigin } from '@angular/cdk/overlay';
import { FormGroup, FormControl, ReactiveFormsModule } from '@angular/forms';
import { MatTableDataSource } from '@angular/material/table';
import { MAT_DIALOG_DATA } from '@angular/material/dialog';

import { MaterialModule } from '@lockton-apps/material';
import { UiModule } from '@lockton-apps/shared/ui/lui';
import { ConfigFormControlDirective } from '@lockton-apps/shared/ui/portal-config';

import { DocumentUploadDialogComponent } from '../document-upload-dialog.component';
import { AdminDocumentDialogData, DocumentUploadRow } from '../models';

@Component({
    selector: 'la-admin-document-upload-dialog',
    imports: [
        CommonModule,
        DocumentUploadDialogComponent,
        MaterialModule,
        UiModule,
        ReactiveFormsModule,
        ConfigFormControlDirective,
    ],
    templateUrl: './admin-document-upload-dialog.component.html',
    styleUrls: ['./admin-document-upload-dialog.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class AdminDocumentUploadDialogComponent {
  addingTagsInProgress!: boolean;
  activeTagsOverlayOrigin!: CdkOverlayOrigin;
  activeTagsControl!: FormControl;

  fileDataSource = new MatTableDataSource<DocumentUploadRow>();
  displayedCols = [
    'document',
    'tags',
    'category',
    'deletionDays',
    'clientVisibility',
    'remove',
  ];

  constructor(@Inject(MAT_DIALOG_DATA) public data: AdminDocumentDialogData) {}

  openTagsOverlay(overlayOrigin: CdkOverlayOrigin, control: FormControl): void {
    this.activeTagsOverlayOrigin = overlayOrigin;
    this.activeTagsControl = control;
    this.addingTagsInProgress = !this.addingTagsInProgress;
  }

  onFilesChanged(rows: DocumentUploadRow[]) {
    this.fileDataSource.data = rows;
  }

  getVisibilityValue(formGroup: FormGroup): boolean {
    const control = formGroup.get('visibility');
    return control ? control.value : false;
  }

  toggleVisibility(formGroup: FormGroup, checked: boolean): void {
    const control = formGroup.get('visibility');

    if (control) {
      control.setValue(checked);
    }
  }

  getButtonToggleLabel(checked: boolean) {
    return checked ? $localize`Visible` : $localize`Hidden`;
  }
}
